import SCTranslations from "../../../components/simpleCrud/SCTranslations.class";
import { SimpleCrudController } from "../../../components/simpleCrud/simpleCrud.controller";
import Field, { FieldApparence, FieldValidation } from "../../../components/simpleCrud/field.class";

export interface Offer {
  name: String,
  discount: Number,
  alreadyPaid: Boolean
}

export default class OffersController extends SimpleCrudController {
  model: Offer = {
    name: '',
    discount: 0,
    alreadyPaid: false
  };
  fields = [
    new Field(
      'name',
      'text'
    ),
    new Field(
      'discount',
      'number',
      {
        apparence: new FieldApparence({ fullwidth: false, isNarrow: true, min: 2 }),
        validation: new FieldValidation({ required: false, min: 1, max: 100 }),
        onChange: (element: Offer) => {
          if (element.discount < 100) {
            element.alreadyPaid = false;
          } else if (element.discount == 100) {
            element.alreadyPaid = true;
          }
        }
      }
    ),
    new Field(
      'alreadyPaid',
      'checkbox',
      {
        apparence: new FieldApparence({ fullwidth: false, isNarrow: true }),
        validation: new FieldValidation({ required: false }),
        onChange: (element: Offer) => {
          if (element.alreadyPaid) {
            element.discount = 100;
          }
        }
      }
    ),
  ]
  errors = {};
  submitted = false;

  translations: SCTranslations = new SCTranslations({
    listTitle: 'LBL_OFFERS',
    listIsEmpty: 'LBL_NO_OFFERS_FOUND',
    newTitleNoData: 'LBL_FIRST_NEW_OFFER',
  });

  /*@ngInject*/
  constructor(Offer, $timeout) {
    super($timeout);
    this.service = Offer;
  }
}



// WEBPACK FOOTER //
// ./client/app/manager/offers/offers.controller.ts